module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "cancel-kanban-be-modal",
    attrs: {
      "hide-footer": "",
      "title": "Edition de votre carte Kanban BE"
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "sm": "2"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-2x fa-fw"
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "5"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-info",
      "block": ""
    },
    on: {
      "click": _vm.savedModification
    }
  }, [_vm._v("\n            Annuler ce Kanban\n          ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9259c436","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CancelKanbanBeModal.vue
// module id = 716
// module chunks = 1